import styled from 'styled-components'

const FilterBarStyle = styled.div.attrs()`
	position: relative;
	flex: 1;
	width: calc(100% - var(--sp72x));
	display: flex;
	justify-content: space-between;

	.load-more-btn {
		transform: translateX(-16px);
	}

	.ant-tabs {
		width:100%;
		.ant-tabs-nav {
			margin: 0;

			&:before {
				display: none;
			}

			.ant-tabs-nav-operations {
				display: none;
			}

			.ant-tabs-nav-wrap {
				.ant-tabs-nav-list {
					.ant-tabs-ink-bar {
						display: none;
					}

					.ant-tabs-tab {
						font-size: var(--h12);
						padding: 0;

						.ant-tabs-tab-btn {
							font-family: PopSemi;
							color: var(--black);
						}

						&-active {
							.ant-tabs-tab-btn {
								font-family: PopSemi;
								color: var(--purple);
								padding-left: var(--sp2x);

								&:before {
									content: '';
									position: absolute;
									top: 50%;
									left: 0;
									background-color: var(--purple);
									border-radius: 50%;
									width: 6px;
									height: 6px;
									transform: translateY(-50%);
								}
							}
						}
					}
				}
			}
		}

		.ant-tabs-content-holder {
			.ant-tabs-tabpane {
				display: flex;
				flex-wrap: wrap;

				.single-people {
					max-width: var(--sp116x);
					width: 100%;
					padding: 0 var(--sp8x);
					margin: 0 auto;
					justify-content: space-between;
					align-items: center;
					padding-bottom: var(--sp4x);
					border-bottom: 1px solid var(--lightGrey);

					&:not(:first-child) {
						margin-top: var(--sp4x);
					}

					&:first-child {
						margin-top: var(--sp10x);
					}

					.left {
						.imageCont {
							width: var(--sp13x);
							padding-top: var(--sp13x);
							border-radius: 10px;
							overflow: hidden;
						}

						.info {
							margin-left: var(--sp3x);

							.place {
								margin: 4px 0 var(--sp1-5x);
							}

							.at {
								margin: 0 var(--spSize);
							}
						}
					}
				}

				/* .single-debate-window {
					width: calc(33.33% - 64px / 3);
					margin-top: var(--sp4x);

					&:nth-child(3n-2) {
						margin-right: var(--sp2x);
					}

					&:nth-child(3n-1) {
						margin-right: var(--sp2x);
						margin-left: var(--sp2x);
					}

					&:nth-child(3n) {
						margin-left: var(--sp2x);
					}
				} */

				.tags {
					/* margin-top: var(--sp8x); */
					margin-top: var(--sp1x);

					.smallTag {
						margin-top: var(--spSize);
					}
				}

                .empty {
                    width:100%;
                    .not-found {
                        width: 50%;
                        padding-top: 40%;
                        margin: 0 auto;
                    }
                }
			}
		}
	}

	@media screen and (max-width: 1390px) {
		/* flex-direction:column-reverse;
		justify-content:flex-end; */
		
		@media screen and (max-width: 1200px){
			.load-more-btn {
				transform: translateX(-12px);
			}
			.filters {
				order:-1;
				position: relative;
				right:unset;
				align-self:flex-end;
				margin-bottom:var(--sp2x);
				margin-right:var(--sp2x);
			}
		}

		.ant-tabs {
			.ant-tabs-nav {

				.ant-tabs-nav-wrap {

					.ant-tabs-nav-list {
						.ant-tabs-tab {
                            font-size: var(--h12);
						}
					}
				}
			}

			.ant-tabs-content-holder {
				.ant-tabs-tabpane {
					display: flex;
					flex-wrap: wrap;

					.single-people {
						max-width: var(--sp116x);
						width: 100%;
						padding: 0 var(--sp8x);
						margin: 0 auto;
						justify-content: space-between;
						align-items: center;
						padding-bottom: var(--sp4x);
						border-bottom: 1px solid var(--lightGrey);

						&:not(:first-child) {
							margin-top: var(--sp4x);
						}

						&:first-child {
							margin-top: var(--sp10x);
						}

						.left {
							.imageCont {
								width: var(--sp13x);
								padding-top: var(--sp13x);
								border-radius: 10px;
								overflow: hidden;
							}

							.info {
								margin-left: var(--sp3x);

								.place {
									margin: 4px 0 var(--sp1-5x);
								}

								.at {
									margin: 0 var(--spSize);
								}
							}
						}
					}

					.tags {
						.smallTag {
							margin-top: var(--spSize);
						}
					}
				}
			}
		}
	}

    @media screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeS}){
        width: 100%;

		.load-more-btn {
			transform: translateX(0);
			padding:var(--sp2x) var(--sp8x);
		}
		.filters {
			margin-right:0;
		}
    }
`

export default FilterBarStyle
